import { useMemo } from 'react';

import { collection, doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { firestore } from '../firebase';
import Person from '../types/Person';

import { useFirestoreError } from './useFirestoreError';

export interface UseUserProfileResult {
  userProfile: Person | null | undefined;
  isUserProfileLoading?: boolean;
  userProfileError?: Error | null;
}

export interface UseUserProfileProps {
  userProfileId: string | null | undefined;
}

export default function useUserProfile(props: UseUserProfileProps): UseUserProfileResult {
  const { userProfileId } = props;

  const userProfileRef = useMemo(() => {
    if (!userProfileId) return null;
    const profileCollection = collection(firestore, 'profile');
    const docRef = doc(profileCollection, userProfileId) as DocumentReference<Person>;
    return docRef;
  }, [userProfileId]);

  const [userProfile, isUserProfileLoading, userProfileError] = useDocumentData<Person>(userProfileRef);
  useFirestoreError('useUserProfile', userProfileError);

  const memoizedResult = useMemo(() => {
    if (!userProfileId) {
      return {
        userProfile: null,
        isUserProfileLoading: false,
        userProfileError: null,
      };
    }

    return {
      userProfile: userProfile || null,
      isUserProfileLoading,
      userProfileError,
    };
  }, [userProfileId, userProfile, isUserProfileLoading, userProfileError]);

  return memoizedResult;
}
